<template>
    <div>
        <div class="formSubmit">
            <vForm class="clearfix" v-model="formData" ref="dataForm">
                <vCol span="24">
                    <vFormItem
                        label="来源单据"
                        class="width-100per"
                        prop="sourceOrderType"
                        :rules="required"
                        labelWidth="120"
                    >
                        <vSelect
                            v-model="formData.sourceOrderType"
                            filterable
                            clearable
                            style="width: 250px"
                        >
                            <vOption
                                v-for="item in sourceOrderTypeList"
                                :key="item.key"
                                :value="item.value"
                                >{{ item.label }}</vOption
                            >
                        </vSelect>
                    </vFormItem>
                </vCol>
                <div style="margin: 10px">
                    <compMutiUpload
                        v-bind="getFileProps"
                        @on-cancel="close"
                        @on-success="success"
                    />
                </div>
            </vForm>
        </div>
        <vLoading loading size="large" transfer v-if="loading"></vLoading>
    </div>
</template>

<script>
import mixin from "../mixin";
export default {
    mixins: [mixin],
    components: {
        compMutiUpload: () => import("@components/templates/mutiUpload"),
    },
    data() {
        return {
            loading: false,
            formData: {},
            required: [
                {
                    required: true,
                    message: "该信息不能为空,请填写",
                },
            ],
        };
    },
    created() {},
    computed: {
        getFileProps() {
            return {
                beforeUpload: (res) => {
                    if (this.formData.sourceOrderType == null) {
                        this.$VMessage.warning("请先选择来源单据");
                        return false;
                    }
                    return res;
                },
                action:
                    process.env.VUE_APP_APIURL_BOSS +
                    "/api/v2/TrackingChange/import",
                name: "excelFile",
                multiple: false,
                data: {
                    sourceOrderType: this.formData.sourceOrderType,
                    orderStatus: 1,
                    contextId: global.SYSID,
                },
                formatter: (res) => {
                    return this.$VMessage.warning("导入成功");
                },
                download: () => {
                    this.handleWebfs(
                        "/static/template/tracking_change_orders.xlsx",
                        {},
                        {
                            executor: "download",
                            type: "url",
                        }
                    );
                },
            };
        },
    },
    methods: {
        close() {
            this.$emit("on-close");
        },
        success() {
            this.close();
            this.$emit("on-update");
        },
    },
};
</script>
